import z from "zod";
import { ProjectIdSchema } from "./idTypes";

// Role names that can be assigned to a user in a context
export const RoleNameSchema = z.enum(["role.collaborator", "role.owner", "role.reader"]);
export type RoleName = z.infer<typeof RoleNameSchema>;

export const ROLE_OWNER: RoleName = "role.owner";
export const ROLE_COLLABORATOR: RoleName = "role.collaborator";

export const EntitlementSchema = z.object({
  feature: z.string(),
  accessible: z.boolean(),
  requiredPlan: z.string(),
});
export type Entitlement = z.infer<typeof EntitlementSchema>;

export const ScopeKeySchema = z.enum(["user", "project", "workspace", "organization", "tenant"]);
export type ScopeKey = z.infer<typeof ScopeKeySchema>;

// Per-scope role map. The object is always present, but each key is optional
// — the backend omits scopes where the user has no effective role.
// User-scope access is identity-enforced, so there's no `user` field here —
// check `capabilities` via `canAt(...)` instead.
export const RolesByScopeSchema = z.object({
  project: RoleNameSchema.optional(),
  workspace: RoleNameSchema.optional(),
  organization: RoleNameSchema.optional(),
  tenant: RoleNameSchema.optional(),
});

// Body for POST /switch-project — persistence only. Records the user's last
// project so the next cold boot can restore it; navigation is URL-driven.
export const SwitchProjectRequestSchema = z.object({
  projectId: ProjectIdSchema,
});
